export default {
  ENGLISH: { key: 'en', text: 'English' },
  JAPANESE: { key: 'ja', text: '日本語' },
};
